import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { BsDatepickerConfig, BsModalRef, BsModalService, de } from "ngx-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import { AuthenticationService } from "../../services/authentication.service";
import { HelperService } from "../../services/helper.service";
import { TosterMessageService } from "../../services/toster-message.service";
import { TrainingService } from "../../services/training.service";

@Component({
  selector: "app-training-calender-modal",
  templateUrl: "./training-calender-modal.component.html",
  styleUrls: ["./training-calender-modal.component.scss"],
  providers: [TrainingService, TosterMessageService, HelperService],
})

export class TrainingCalenderModalComponent implements OnInit {

  public colorTheme = "theme-blue";
  public bsConfig: Partial<BsDatepickerConfig>;

  @ViewChild("swalModal") public swalModal: any;
  @ViewChild("errorMessageHtml") public errorMessageHtml: any;
  @ViewChild("f") public form: any;
  @ViewChild("swalModalDelete") public swalModalDelete: any;
  public companySystemID: any;
  public successMsg: string = "";
  public htmlErrorMessage: string = "";
  isCanceld: boolean = false;
  @ViewChild("swalModalNotAccess") public swalModalNotAccess: any;


  public dbData = [];
  public masterData: any = {};
  public calendarID: any;
  public calendarType: any;
  public is_menu: boolean = false;
  isEditable: boolean = true;
  trainingRecordSaved: boolean;

  constructor(
    public bsModalRef: BsModalRef,
    public bsModalRefsCalendar: BsModalRef,
    private trainingService: TrainingService,
    private helperService: HelperService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private authenticationService: AuthenticationService,
    private modalService: BsModalService, private tosterMessageService: TosterMessageService) {
    this.companySystemID = this.helperService.getSelectedCompanyId();
  }


  public closeModal() {
    //console.log("Close Popup Calendar");
    this.modalService.setDismissReason("trainingRecordSaved");
    this.bsModalRef.hide();
    if (this.trainingRecordSaved) {
      this.modalService.setDismissReason("trainingRecordSaved");
    }
  }





  public ngOnInit() {

    this.calendarID = Number(localStorage.getItem("training-record-id"));
    localStorage.removeItem("training-record-id");

    this.calendarType = Number(localStorage.getItem("training-record-type"));
    localStorage.removeItem("training-record-type");

    this.trainingRecordTable();    
  }


  public trainingRecordTable() {
    this.spinner.show();
    const that = this;
    //console.log(that.calendarID);
    
    if(that.calendarType === 1){
      //console.log(this.calendarType);
      that.trainingService
      .trainingRecordTableCalenderNomi()
      .post({
        calendarID: that.calendarID,
        companySystemID: that.companySystemID,
      })
      .subscribe((resp) => {
        that.dbData = resp.data;
        //console.log(that.dbData);
        this.spinner.hide();
      }, (error) => {
        this.spinner.hide();
        this.tosterMessageService.showError("Error", 'Not Found');
      });


    }else {
      //console.log(this.calendarType);
      that.trainingService
      .trainingRecordTableCalender()
      .post({
        calendarID: that.calendarID,
        companySystemID: that.companySystemID,
      })
      .subscribe((resp) => {
        that.dbData = resp.data;
        //console.log(that.dbData);
        this.spinner.hide();
      }, (error) => {
        this.spinner.hide();
        this.tosterMessageService.showError("Error", 'Not Found');
      });
    }
  }




  breakText(text: string, maxLength: number): string[] {
    if (!text || text.length <= maxLength) {
      return [text];
    }
    const lines = [];
    let currentIndex = 0;
    while (currentIndex < text.length) {
      lines.push(text.substring(currentIndex, currentIndex + maxLength));
      currentIndex += maxLength;
    }
    return lines;
  }




}



// WEBPACK FOOTER //
// /app/src/app/training/training-calender-modal/training-calender-modal.component.ts